import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

interface LoyaltyState {
  balance: number;
  transactions: any[];
  isLoading: boolean;
}

const initialState: LoyaltyState = {
  balance: 0,
  transactions: [],
  isLoading: false,
};

export const fetchLoyalty = createAsyncThunk(
  'loyalty/fetch',
  async (_, { getState }) => {
    const state = getState() as { auth: { accessToken: string | null } };
    const response = await axios.get(
      `${API_BASE_URL}/users/me/impact`,
      { headers: { Authorization: `Bearer ${state.auth.accessToken}` } }
    );
    return {
      balance: response.data.data.impact.neoTokenBalance,
      transactions: response.data.data.impact.recentActivity || [],
    };
  }
);

const loyaltySlice = createSlice({
  name: 'loyalty',
  initialState,
  reducers: {
    updateBalance: (state, action) => {
      state.balance = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLoyalty.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchLoyalty.fulfilled, (state, action) => {
        state.isLoading = false;
        state.balance = action.payload.balance;
        state.transactions = action.payload.transactions;
      });
  },
});

export const { updateBalance } = loyaltySlice.actions;
export default loyaltySlice.reducer;

